import { __decorate } from "tslib";
import { lazyConsumer } from '@1inch-community/core/lazy';
import { observe, translate } from '@1inch-community/core/lit-utils';
import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { defer } from 'rxjs';
import '../../../../chain-selector';
import { walletAccountContext } from '../../context';
import '../../i18n';
import '../wallet-account-card';
import { walletAccountHeaderStyle } from './wallet-account-header.style';
let WalletAccountHeaderElement = class WalletAccountHeaderElement extends LitElement {
    constructor() {
        super(...arguments);
        this.context = lazyConsumer(this, { context: walletAccountContext });
        this.chainListView$ = defer(() => this.context.value.chainFilter$);
    }
    static { this.tagName = 'inch-wallet-account-header'; }
    static { this.styles = [walletAccountHeaderStyle]; }
    render() {
        return html `
      <div class="container">
        <inch-wallet-account-card></inch-wallet-account-card>
        <div class="tokens-list-title-container">
          <span class="tokens-list-title"
            >${translate(`widgets.wallet-account-view.tokens-list.title`)}</span
          >
          <inch-chain-selector
            .selectedChainIdList="${observe(this.chainListView$)}"
            @changeSelectedChainIdList="${(event) => this.context.value.onChangeChainFilter(event.detail.value)}"
          ></inch-chain-selector>
        </div>
      </div>
    `;
    }
};
WalletAccountHeaderElement = __decorate([
    customElement(WalletAccountHeaderElement.tagName)
], WalletAccountHeaderElement);
export { WalletAccountHeaderElement };
//# sourceMappingURL=wallet-account-header.element.js.map